import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoaderComponent } from '@components/shared/loader/loader.component';
import { HttpService } from '@services/http.service';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrl: './landing.component.scss',
  standalone:true,
  imports:[CommonModule,LoaderComponent]
})
export class LandingComponent implements OnInit {
  isLoading = true;
  router=inject(Router);
  httpService=inject(HttpService);

  ngOnInit(): void {
    this.httpService.get('access').subscribe(() => {
      this.isLoading = false;
      this.router.navigate(['main', 'crt', 'search']);
    });
  }
}
